/**
 * Rewards page - make the CTA buttons open the widget
 */
(function () {
  setTimeout(() => {
    const isRewardsPage = document.querySelector(".suffix-rewards");
    const rewardsBtn = document.querySelector(".c-launchBubble-button");

    if (isRewardsPage && rewardsBtn) {
      document.querySelectorAll('a[href="#"]').forEach((el) => {
        el.addEventListener("click", (evt) => {
          evt.preventDefault();
          rewardsBtn.focus();
          rewardsBtn.click();
        });
      });
    }
  }, 1500);
})();

/**
 * "Add 6 (Full Case)" — use the theme's native Add-to-Cart handler (AJAX/no redirect)
 * Requirements:
 *  - Product form contains a quantity input (hidden or visible). If not, we create one.
 *  - Button markup: <button type="button" class="btn btn--full btn--add-pack" data-pack-qty="6">Add 6 (Full Case)</button>
 */
(function () {
  // Prevent double-initialization in case this file gets loaded twice
  if (window.__addPackHandlerBound__) return;
  window.__addPackHandlerBound__ = true;

  function findProductForm(btn) {
    // Button should live inside the product form; fallback to nearby containers if needed
    const form = btn.closest('form');
    if (form) return form;

    const container = btn.closest('.product-single__form, .product, .product-form, [data-product-form]');
    return container ? (container.querySelector('form') || null) : null;
  }

  function getOrCreateQtyInput(form) {
    // Prefer an existing qty field if present
    let qty =
      form.querySelector('input[name="quantity"]') ||
      form.querySelector('input[type="number"][name="quantity"]') ||
      form.querySelector('[data-quantity-input]');

    if (!qty) {
      qty = document.createElement('input');
      qty.type = 'hidden';
      qty.name = 'quantity';
      qty.value = '1';
      form.appendChild(qty);
    }
    return qty;
  }

  function getThemeAddButton(form) {
    // Common selectors across popular Shopify themes
    return (
      form.querySelector('[data-add-to-cart]') ||
      form.querySelector('button[name="add"]') ||
      form.querySelector('button[type="submit"]')
    );
  }

  document.addEventListener('click', function (e) {
    const packBtn = e.target.closest('.btn--add-pack');
    if (!packBtn) return;

    e.preventDefault();
    e.stopPropagation();

    // Simple double-click guard
    if (packBtn.dataset.loading === 'true') return;
    packBtn.dataset.loading = 'true';

    try {
      const form = findProductForm(packBtn);
      if (!form) throw new Error('No product form found near Add 6 button');

      const qtyInput = getOrCreateQtyInput(form);
      const addBtn = getThemeAddButton(form);
      if (!addBtn) throw new Error('No Add to Cart button found in product form');

      const previous = qtyInput.value || '1';
      const packQty = parseInt(packBtn.dataset.packQty || '6', 10);

      // Set to 6, dispatch change so any listeners update, then click the theme's add button
      qtyInput.value = String(packQty);
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      addBtn.click();

      // Reset quantity back after the add so default UI remains at previous (usually 1)
      setTimeout(function () {
        qtyInput.value = previous;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        packBtn.dataset.loading = 'false';
      }, 500);
    } catch (err) {
      console.error('[Add 6] error:', err);
      packBtn.dataset.loading = 'false';
      alert('Sorry—couldn’t add that to your cart. Please try again.');
    }
  }, { capture: true });
})();
